import { rangeTypes } from '../constants'

export const options = [
  { label: 'Rango de fechas', value: rangeTypes.fixed },
  { label: 'Dinámico', value: rangeTypes.dynamic },
]
